<template>
  <div class="ui form">
    <h4 class="ui dividing header">{{ $t("settings") }}</h4>
    <div class="two fields">
      <div class="field">
        <label for>{{ $t("account") }}</label>
        <div class="ui toggle checkbox">
          <input type="checkbox" name="public" v-model="stp.register_account" />
          <label>{{ $t("register an account on student creation") }}</label>
        </div>
      </div>
      <div class="field" v-bind:class="{ disabled: !stp.register_account }">
        <label for>{{ $t("account type") }}</label>
        <div class="ui selection dropdown" ref="account_type_dropdown">
          <input type="hidden" name="ddwn" />
          <i class="dropdown icon"></i>
          <div class="default text"></div>
          <div class="menu"></div>
        </div>
      </div>
    </div>
    <h4 class="ui dividing header">
      <i class="student icon"></i> {{ $t("student movement integration") }}
    </h4>
    <div class="field">
      <label for="">{{ $t("distribution policy") }}</label>
      <div class="ui selection dropdown" ref="policy_dropdown">
        <input type="hidden" name="policy" />
        <i class="dropdown icon"></i>
        <div class="default text">{{ $t("select one") }}</div>
        <div class="menu">
          <div class="item" data-value="none">
            {{ $t("do not distribute on student movements") }}
          </div>
          <div class="item" data-value="oldest">
            {{ $t("oldest movements first") }}
          </div>
          <div class="item" data-value="manual">
            {{ $t("manually select movents") }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { local_api, stringify } from "@/utils";

export default {
  name: "StudentAccountConfigurationModalSettings",
  props: { setup_in: Object },
  components: {},
  computed: {},
  data() {
    return {
      setup: {},
      stp: {
        register_account: true,
        account_type: "",
        student_movement_policy: "",
      },
    };
  },
  methods: {
    getData() {
      return this.stp;
    },
  },
  mounted() {
    let vm = this;
    local_api(vm, "post", "/account_type/do-get-list", {})
      .then((accountTypes) => {
        let vls = accountTypes.map((t) => {
          return { name: t.name, value: t.type_id };
        });

        window
          .jQuery(vm.$refs.account_type_dropdown)
          .dropdown("setup menu", { values: vls })
          .dropdown({
            onChange(value) {
              vm.stp.account_type = value;
            },
          });

        setTimeout(() => {
          if (vm.setup_in.register_account)
            vm.stp.register_account = vm.setup_in.register_account;
          if (vm.setup_in.account_type)
            window
              .jQuery(vm.$refs.account_type_dropdown)
              .dropdown("set selected", vm.setup_in.account_type);
        }, 200);
      })
      .catch((err) => {
        vm.$alertify.error(stringify(err));
      });

    /** */

    window.jQuery(vm.$refs.policy_dropdown).dropdown({
      onChange(value) {
        vm.stp.student_movement_policy = value;
      },
    });

    setTimeout(() => {
      if (vm.setup_in.student_movement_policy) {
        console.log("set selected", vm.setup_in.student_movement_policy);
        window
          .jQuery(vm.$refs.policy_dropdown)
          .dropdown("set selected", vm.setup_in.student_movement_policy);
      }
    }, 200);
  },
  watch: {},
  updated: function() {},
};
</script>
